export function PProcessConcat(concatCache, s, dbObj, curDef, docRef) {
  var parts = s.split("[");
  var n = parts.length;
  for (var i = 0; i < n; i++) {
    var p = parts[i];
    var parts2 = p.split("]");
    var n2 = parts2.length;

    if (n2 > 1) {
      var v = "";
      if (parts2[0].length > 0) v = "[" + parts2[0];
      if (v.length > 0) concatCache.push(v);
      var v2 = parts2[1];
      if (v2.length > 0) concatCache.push(v2);
    } else if (parts2[0].length > 0) concatCache.push(parts2[0]);
  }
}
